import { useNavigate } from "react-router-dom";
import "./radio.css";

function PillRadio({ items, setTab, active, setTabDesktopContent }) {
  const navigate = useNavigate();
  return (
    <div className="pill-radio-container">
      {items.map((item, index) => {
        return (
          <div
            key={index}
            onClick={() => {
              setTab(item.id);
              setTabDesktopContent(item.item);
              if (item.id === 1) {
                navigate(`/business/treasury/deposit`);
              } else if (item.id === 3) {
                navigate(`/digital-banking-overview`);
              } else if (item.id === 2) {
                navigate(`/about`);
              } else {
                navigate(`/`);
              }
            }}
            className={`item cursor-pointer ${
              active === item.id ? `active` : ``
            }`}
          >
            {item.name}
          </div>
        );
      })}
    </div>
  );
}

export default PillRadio;
